import React from "react"
import { RightChevron } from "assets/helper/icons"
import { Button } from "components/button"
import { useLayout } from "contexts/components/LayoutContext"
import { Link } from "gatsby"
import "./blog-banner-list-item.module.scss"

interface BlogBannerListItemProps {
  heading?: string
  description?: string
  slug: string
  hasButton?: boolean
  date?: string
}

export const BlogBannerListItem = ({
  heading,
  slug,
  date,
  hasButton,
}: BlogBannerListItemProps) => {
  const { linkedPagesUrlPathCodex } = useLayout()
  const pageSlug = linkedPagesUrlPathCodex[slug] || "404"
  const path = pageSlug.startsWith("/") ? pageSlug : `/${pageSlug}`

  return (
    <Link className="fr-blog-banner-list__item u-flex-center-align" to={path}>
      <div className="u-container-header">
        <div className="fr-blog-banner-list__item-date">{date}</div>
        <h3 className="fr-blog-banner-list__item-heading u-text--align-left">
          {heading}
        </h3>
      </div>

      {hasButton && (
        <div className="button--outline-secondary fr-blog-banner-list__item-btn">
          Read more <RightChevron className="fr-blog-banner-list__item-icon" />
        </div>
      )}
    </Link>
  )
}
